import React from "react";
import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import { Menu } from "semantic-ui-react";

const MenuReconciliation = () => {

    const accounting = useSelector(state => state.accounting);

    return (
        <Menu.Menu>
            <NavLink end className="item" to={`/accountings/${accounting.id}/reconciliation`}>
                <span>Lettrage</span>
            </NavLink>
            <NavLink end className="item" to={`/accountings/${accounting.id}/reconciliation/unreconcilate`}>
                <span>Délettrage</span>
            </NavLink>
        </Menu.Menu>
    );
}

export default MenuReconciliation;